$(function() {
	// @codekit-prepend 'js/functions.js'
	// @codekit-prepend 'js/donate.js'
	
});